import axios from 'axios'
import config from './config'
import { Toast } from 'vant';

axios.defaults.baseURL = config.Host
axios.defaults.headers = {
  // 'Content-Type': 'application/x-www-form-urlencoded'
}
// 设置超时时间
axios.defaults.timeout = 300000
// 允许携带cookie
axios.defaults.withCredentials = true


// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status === 200) {
      return response;
    } else {
      if (res.message !== '' && res.message !== null) {
        Toast(res.message);
      }
    }
    return Promise.reject(res.message);
  },
  (error) => {
    Toast('请求超时，请检查网络后重试！');
    return Promise.reject(error);
  }
);

export default axios